// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';

import { validateCardHolderName } from './card-holder-name';
import { validateCardNumber } from './card-number';
import { validateCardExpiryDate } from './card-expiry-date';
import { validateCardSecurityCode } from './card-security-code';
import { validateAcceptVisaTerms } from './accept-visa-terms';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'cardHolderName':
      return onlyWhen('field_card_holder_name') && validateCardHolderName(userInputValue);

    case 'cardNumber':
      return onlyWhen('field_card_number') && validateCardNumber(userInputValue);

    case 'cardExpiryDate':
      return onlyWhen('field_card_expiry_date') && validateCardExpiryDate(userInputValue);

    case 'cardSecurityCode':
      return onlyWhen('field_card_security_code') && validateCardSecurityCode(userInputValue, userInputValues['cardNumber']);

    case 'acceptVisaTerms':
      return onlyWhen('field_accept_visa_terms') && validateAcceptVisaTerms(userInputValue, userInputValues['cardNumber']);

    default:
      return undefined;
  }
}
